<footer class="p-footer">
  <section class="p-footer__body">
    <!--    <h1 class="p-footer__company">-->
    <!--      <img src="./assets/img/Tongo_logo_new_2_white.svg" alt="Tongo logo" />-->
    <!--    </h1>-->
    <aside class="p-footer__copyright">
      <span
        [innerHtml]="
          'footer.component.copyright_text'
            | localise: 'Copyright &copy; Tongo, 2026. All rights reserved'
            | safe: 'html'
        "></span>
      <a
        class="url m-r-24"
        href="https://gettongo.com/electronic-disclosure-and-consent/"
        target="_blank"
        >{{
          'footer.component.electronic_disclosure_link'
            | localise: 'Electronic Disclosure'
        }}</a
      >
      @if (authenticationService.isAuth | async) {
        <span class="contact-info"
          >{{ 'footer.component.phone_text' | localise: 'Phone: '
          }}{{ sharedService.companyPhoneFormatted }}</span
        >
        <span content="email=no" class="contact-info text-decoration-none"
          >{{
            'footer.component.email_text' | localise: 'Email: '
          }}support&#64;&#8203;gettongo.com</span
        >
      }
      <a href="https://gettongo.com/terms-and-conditions/" target="_blank">{{
        'footer.component.terms_and_conditions_link'
          | localise: 'Terms and Conditions'
      }}</a>
      <a href="https://www.gettongo.com/data-policy" target="_blank">{{
        'footer.component.privacy_policy_link' | localise: 'Privacy Policy'
      }}</a>
    </aside>
  </section>
</footer>
